<template>
  <div>
        <!--登录表单-->
        <el-form :inline="true" :model="formData" :rules="rules" ref="formData" class="full-form" :hide-required-asterisk="true" label-width="80px">
            <el-form-item  label="当前销售" v-if="changeUseItem.truename">
                {{changeUseItem.truename}}
            </el-form-item>
            <el-form-item label="销售职位" prop="position_name">
                    <el-autocomplete
                    popper-class="my-autocomplete"
                    v-model="formData.position_name"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入或选择职位"
                    @select="handleSelect"
                    style="width: 100%;"
                    >
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.name }}</div>
                    </template>
                    </el-autocomplete>
            </el-form-item>
            <el-button class="mt-3" type="primary" style="width: 100%;" @click="submitForm('formData')"  block>确认更改</el-button>
        </el-form>
  </div>
</template>

<script>
import { mapState,mapGetters,mapActions} from 'vuex'
export default {
  name: 'ChangePosition',
  components: {},
  props: {
    changeUseItem: {
      type:Object,
      default:()=>{}
    },
    changeStoreid: {
      type:Number,
      default:0
    }
  },
  data() {
    return {
        formData:{
            store_id:'',
            uid:'',
            position_name:'',
        },
        rules: {  
            position_name: [
                { required: true, message: '请输入职位', trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                    // 空值交给required校验处理
                    if (!value) return callback()
                    // 纯中文正则
                    const reg = /^[\u4e00-\u9fa5]+$/
                    if (!reg.test(value)) {
                        return callback(new Error('职位只能输入汉字，不可包含英文、数字、特殊符号'))
                    }
                    callback()
                    },
                    trigger: ['blur', 'change']
                },
                { max: 6, message: '输入职位不得大于6个汉字', trigger: 'blur' }
            ],
      },
    };
  },
  computed: {},
  watch: {
    changeUseItem:{
        handler(newVal,oldVal){
            console.log(newVal)
            this.formData.position_name = newVal.position_name||'';
        },
        immediate:true
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_SetUserStorePositionName']),
        // 添加验证表单
        async submitForm(formName) {
            await this.$refs[formName].validate(async valid => {
                if (valid) {
                    // 提交表单数据
                    this.formData.store_id = this.changeStoreid;
                    this.formData.uid = this.changeUseItem.uid||'';
                    this.POST_SetUserStorePositionName({data:this.formData,successFun:()=>{
                        this.$emit('changeSuccess',this.changeUseItem,this.formData.position_name)
                    }})
                } else {    
                return false;
                }
            });
        },
        querySearch(queryString, cb) {
            var restaurants = this.$GVAR.position;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                // 兜底：不存在name直接返回false
                if (!restaurant || !restaurant.name) return false
                const name = restaurant.name.toLowerCase();
                const q = queryString.toLowerCase();
                return name.includes(q);
            };
        },
        handleSelect(item) {
            this.formData.position_name = item.name;
        },
    }
};
</script>

<style lang="scss" scoped>
    .full-form{
        display: flex;
        flex-direction: column; 
    }
</style>

<style>
    .full-form .el-form-item__content{
        width: 81%;
    }
    .full-form .el-select{
        width: 100%;
    }
</style>
